/**
 * 组合函数（同步）
 * @param fns
 */
export var compose = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function (value) {
        var re = value;
        for (var i in fns) {
            if (fns[i]) {
                var newValue = fns[i](re);
                if (newValue) {
                    re = newValue;
                }
                else {
                    return re;
                }
            }
        }
        return re;
    };
};
/**
 * 组合函数（异步）
 * @param fns
 */
export var composeAsync = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function (value) {
        return new Promise(function (resolve) {
            var i = 0;
            var callFn = function (value) {
                if (i >= fns.length) {
                    resolve(value);
                }
                else {
                    var newValue = fns[i++](value);
                    if (newValue instanceof Promise) {
                        newValue.then(function (newValue) {
                            newValue
                                ? callFn(newValue)
                                : resolve(value);
                        });
                    }
                    else {
                        newValue
                            ? callFn(newValue)
                            : resolve(value);
                    }
                }
            };
            callFn(value);
        });
    };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/grey-group-function/index.js
// module id = 307
// module chunks = 0